// "Safest bets first": highest displayed estimated chance of a place first (unrounded model value).
// Rows without an estimate go last; ties break by grade-match band, gap, then name and id so order is stable.
const BAND_RANK = { likely: 0, target: 1, ambitious: 2, highly_ambitious: 3, long_shot: 3 };

const chance = (r) => {
  const v = r?.classification?.admit_probability?.value;
  return typeof v === "number" && Number.isFinite(v) ? v : null;
};

export function compareSafest(a, b) {
  const pa = chance(a);
  const pb = chance(b);
  if (pa == null && pb != null) return 1;
  if (pb == null && pa != null) return -1;
  if (pa != null && pb != null && pa !== pb) return pb - pa;
  const ba = BAND_RANK[a?.classification?.bucket] ?? 9;
  const bb = BAND_RANK[b?.classification?.bucket] ?? 9;
  if (ba !== bb) return ba - bb;
  const ga = a?.classification?.gap_score ?? -Infinity;
  const gb = b?.classification?.gap_score ?? -Infinity;
  if (ga !== gb) return gb - ga;
  const n = (a?.university_name || "").localeCompare(b?.university_name || "");
  if (n) return n;
  return String(a?.degree_id || "").localeCompare(String(b?.degree_id || ""));
}
